
<template>
  <main>
    <!-- Campaign general info section -->
    <CampaignInfoSection :parCampaignId="this.$route.params.id" :parPageRights="pageRights" />
    <!-- CouponHistory info section -->
    <section class="whiteBox">
      <div class="content">
        <div class="relative">
          <button @click="displayFilter = !displayFilter" class="outline">
            <i class="fas fa-filter fa-flip-horizontal"></i>
            {{$t("button.filter")}}
          </button>
          <FiltresForCouponHistory
            v-if="displayFilter"
            :parOptions="options.object"
            :parCampaignId="campaignId"
            @clear="clearFilter"
            @filter="getFilter"
          ></FiltresForCouponHistory>
          <div
            style="
        display: inline-grid;
    float: right;
    padding: 0px 30px;
    margin-right: 22px;"
          >
            <!-- export button -->
            <button
              class="outline"
              @click="exportGlobalInfosCSV('coupon_history',campaign,null,currentCouponHistory)"
              v-if="pageRights.exportCampaign"
            >
              <i class="fas fa-arrow-up rotate"></i>
              {{$t('button.export')}}
            </button>
            <div class="spacer-10"></div>
            <label>{{$t("couponHistory.numberOfLines")}} :</label>
            <select v-model="itemsPerPage" @change="refreshPagination()">
              <option v-for="number in itemsPerPageTable" :key="number" :value="number">{{number}}</option>
            </select>
          </div>
        </div>
        <div class="spacer-10"></div>
        <div class="spacer-10"></div>
        <div class="row">
          <p class="accentuate">{{$t('campaigns.lastUsesSection')}}</p>
        </div>
        <div class="row">
          <table>
            <thead>
              <tr>
                <th class="accentuate">{{$t('coupons.couponCode')}}</th>
                <th class="accentuate">{{$t('dateManagement.date')}}</th>
                <th class="accentuate">{{$t('campaigns.discount')}}</th>
                <th class="accentuate">{{$t('campaignStatus.status')}}</th>
                <th class="accentuate">{{$t('couponHistory.idTransaction')}}</th>
                <th class="accentuate">{{$t('couponHistory.idClient')}}</th>
              </tr>
            </thead>
            <tbody>
              <!--<tr v-for="couponuse in paginate" :key="couponuse.title"> -->
              <tr v-for="couponuse in currentCouponHistory" :key="couponuse.title">
                <td>{{couponuse['coupon-value']}}</td>
                <td>{{moment(couponuse['transaction-date']).format(`DD/MM/YYYY ${$t('dateManagement.at')} HH[${$t('dateManagement.hourSeparator')}]mm`)}}</td>
                <td>
                  <span
                    v-if="couponuse['applied-discount']!=0"
                    class="chipValue lightorange"
                  >{{'-'+(couponuse['applied-discount']/100).toFixed(2) + convertCurrencyToSymbol(couponuse['discount-currency'])}}</span>
                  <span v-else class="chipValue void">{{$t('discountValue.noDiscount')}}</span>
                  <span>{{couponuse['product-name']}} | {{couponuse['sales-channel-name']}}</span>
                </td>
                <td>
                  <p
                    v-if="couponuse['transaction-status']==0"
                    class="chip grey"
                  >{{$t('couponStatus.notUsed')}}</p>
                  <p
                    v-if="couponuse['transaction-status']==1"
                    class="chip greyBold"
                  >{{$t('couponStatus.retrieved')}}</p>
                  <p
                    v-if="couponuse['transaction-status']==2"
                    class="chip lightorange"
                  >{{$t('couponStatus.verified')}}</p>
                  <p
                    v-if="couponuse['transaction-status']==3"
                    class="chip orange"
                  >{{$t('couponStatus.autorized')}}</p>
                  <p
                    v-if="couponuse['transaction-status']==4"
                    class="chip green"
                  >{{$t('couponStatus.confirmed')}}</p>
                </td>
                <td>{{couponuse['merchant-order-id']}}</td>
                <td>{{couponuse['merchant-reference']}}</td>
              </tr>

              <tr v-if="this.currentCouponHistory == 0">
                <div class="row">
                  <p class="pStrong">Aucun résultat</p>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="spacer-10"></div>
        <div class="spacer-10"></div>
        <div class="spacer-10"></div>
        <div v-if="currentCouponHistory.length>0" class="row pagination">
          <ul>
            <li v-for="pageNumber in  parseInt(totalPages, 10)" :key="pageNumber">
              <a
                v-if="Math.abs(pageNumber - currentPage) < 3 || pageNumber ==  parseInt(totalPages, 10) || pageNumber == 1"
                v-bind:key="pageNumber"
                @click="sliceRequestToPaginate(pageNumber,itemsPerPage,options.string)"
                :class="{active: currentPage === pageNumber, last: (pageNumber ==  parseInt(totalPages, 10) && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 1 && Math.abs(pageNumber - currentPage) > 3)}"
              >{{ pageNumber }}</a>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </main>
</template>
<script>
import Campaigns from "@/services/Campaigns";
import GroupsOfDiscounts from "@/services/GroupsOfDiscounts";
import Discounts from "@/services/Discounts";
import CampaignInfoSection from "@/components/campaigns/manageCampaign/CampaignInfoSection.vue";
import bubble from "@/mixins/bubble";
import getCampaignDetails from "@/mixins/getCampaignDetails";
import FiltresForCouponHistory from "@/components/campaigns/campaignDetails/FiltresForCouponHistory.vue";
import generalMethods from "@/mixins/generalMethods";
import CouponHistory from "@/services/CouponHistory";
export default {
  mixins: [bubble, getCampaignDetails, generalMethods],
  components: {
    CampaignInfoSection,
    FiltresForCouponHistory
  },
  computed: {
    paginate: function() {
      if (!this.currentCouponHistory || this.currentCouponHistory.length == 0) {
        return;
      }
      var index = this.currentPage * this.itemsPerPage - this.itemsPerPage;
      return this.currentCouponHistory.slice(index, index + this.itemsPerPage);
    }
  },
  mounted() {
    this.campaignId = this.$route.params.id;
    this.getCampaignInfoById(this.campaignId);
    this.refreshPagination();
  },
  data() {
    return {
      couponTable: [],
      couponHistory: [],
      currentCouponHistory: [],
      currentPage: 1,
      itemsPerPageTable: [10, 50, 100, 250, 500],
      itemsPerPage: 10,
      displayFilter: false,
      campaignId: {},
      campaign: {},
      totalPages: 0,
      options: { object: {}, string: "" },
      sort: {
        order: -1,
        type: "last-logging-date"
      }
    };
  },
  methods: {
    clearFilter() {
      this.displayFilter = false;
      this.options = { object: {}, string: "" };
      this.currentCouponHistory = this.couponHistory;
      this.refreshPagination();
    },
    sliceRequestToPaginate(pageNumber, itemsPerPage, stringFilter) {
      this.currentPage = pageNumber;
      CouponHistory.getByCampaignIdPaginateWithFilter(
        this.campaignId,
        itemsPerPage,
        pageNumber,
        stringFilter
      ).then(res => {
        // modif de la liste
        if (res.status == 200) {
          this.totalPages = res.headers["nbtotalpage"];
          this.currentCouponHistory = res.data;
        }
      });
      // if (!this.currentCouponHistory || this.currentCouponHistory.length == 0) {
      //  return;
      // }
    },
    getFilter(filter) {
      this.displayFilter = false;
      this.currentPage = 1;
      this.itemsPerPage = 10;
      this.options = filter;
      this.refreshPagination();
      // this.options = filter;
    },
    refreshPagination() {
      this.sliceRequestToPaginate(
        this.currentPage,
        this.itemsPerPage,
        this.options.string
      );
    },
    setPage(pageNumber) {
      this.currentPage = pageNumber;
    },
    archiveGroupOfDiscounts(data) {
      GroupsOfDiscounts.partialUpdate(data.id, {
        archived: !data.archived
      }).then(res => {
        if (res.status == 204) {
          data.archived = !data.archived;
        }
      });
    },
    getCouponHistory(campaignId) {
      CouponHistory.getByCampaignId(campaignId).then(res => {
        if (res.status == 200) {
          res.data.sort(function(a, b) {
            //DESC order
            return a["transaction-date"] < b["transaction-date"]
              ? 1
              : a["transaction-date"] > b["transaction-date"]
              ? -1
              : 0;
          });
          this.couponHistory = res.data;
          this.currentCouponHistory = res.data;
        }
      });
    },
    getCampaignInfoById(id) {
      if (id) {
        Campaigns.getById(id).then(res => {
          if (res.data["number-of-used-coupons"] == null)
            res.data["number-of-used-coupons"] = "0";
          else
            res.data["number-of-used-coupons"] = res.data[
              "number-of-used-coupons"
            ].toLocaleString("fr");

          if (res.data["max-number-of-coupons"] == null)
            res.data["max-number-of-coupons"] = "0";
          else
            res.data["max-number-of-coupons"] = res.data[
              "max-number-of-coupons"
            ].toLocaleString("fr");
          this.campaign = res.data;
          this.getDiscountsByCampaignId(id);
          this.checkUserRights();
        });
      }
    },
    getDiscountsByCampaignId(campaignId) {
      GroupsOfDiscounts.get(campaignId).then(resGoD => {
        if (resGoD.status == 200) {
          Discounts.getByCampaignId(campaignId).then(resD => {
            this.discountsList = resD.data;
            for (var i = 0; i < resGoD.data.length; i++) {
              resGoD.data[i]["discounts-list"] = resD.data.filter(
                x => x["group-of-discounts-id"] == resGoD.data[i]["id"]
              );
            }
            this.groupsOfDiscounts = resGoD.data;
            this.discount = resD.data;

            this.refreshPagination();
          });
        }
      });
    },
    modifyDiscountToGroupOfDiscount(currentdiscount) {
      this.discountMethod = "modify_discount";
      this.curDiscount = currentdiscount;
      this.displayDiscountManagement = true;
    }
  }
};
</script>


<style scoped>
.pagination {
  display: inline-block;
}

.pagination a {
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color 0.3s;
  border: 1px solid #ddd;
}

.pagination a.active {
  background-color: #0275d8;
  color: white;
  border: 1px solid #0275d8;
}

.pagination a:hover:not(.active) {
  background-color: #ddd;
}
.current {
  color: red;
}
ul {
  padding: 0;
  list-style-type: none;
}
li {
  display: inline;
  margin: 5px 5px;
}

a.first::after {
  content: "...";
}

a.last::before {
  content: "...";
}
</style>

